import { database } from "../index";
import { BUSINESS_SCHEMA, JOURNAL_SCHEMA, STAFF_SCHEMA } from "../schema";
import { Q } from "@nozbe/watermelondb";
import {
  getAttendancesByJournal,
  getStaffAttendanceByDate,
} from "./attendance";

const journal_model = database.collections.get(JOURNAL_SCHEMA);

export const getJournalByID = async (id) => await journal_model.find(id);
export const getJournalsById = async (staff_id) =>
  await journal_model.query(Q.on(STAFF_SCHEMA, "id", staff_id)).fetch();
export const observeActiveJournals = (id) =>
  journal_model
    .query(
      Q.where("business_id", id),
      Q.on(BUSINESS_SCHEMA, Q.where("is_active", true))
    )
    .observeWithColumns(["last_updated_at", "amount"]);

export const getJournalsByBusiness = async (id) =>
  await journal_model.query(Q.on(BUSINESS_SCHEMA, "id", id)).fetch();

export const bulkUpdateJournalByStaff = async (allStaff, date) => {
  await database.write(async () => {
    const allRecords = await prepareStaffJournalUpdation(allStaff, date);
    await database.batch(...allRecords);
  });
};

const prepareStaffJournalUpdation = async (allStaff, date) => {
  return await Promise.all(
    allStaff.map(async (staff) => {
      try {
        let att_date = new Date(date);
        att_date.setHours(0, 0, 0, 0);
        let att_at = att_date.getTime();

        let attendance = await getStaffAttendanceByDate(staff.id, att_at);

        if (
          attendance.length &&
          attendance[0].journal &&
          attendance[0].journal.id
        ) {
          const attendances = await getAttendancesByJournal(
            attendance[0].journal.id
          );
          let total = attendances.reduce((value, data) => {
            return (value += data.payment);
          }, 0);

          const getJournal = await journal_model.find(attendance[0].journal.id);

          return getJournal.prepareUpdate((j) => {
            j.amount = total;
            j.last_updated_at = new Date().getTime();
          });
        } else {
          // return true
        }
      } catch (err) {
      }
    })
  );
};

export const bulkUpdateJournals = async (journals) => {
  await database.write(async () => {
    const allRecords = await prepareUpdation(journals);
    await database.batch(...allRecords);
  });
};

const prepareUpdation = async (journals) => {
  return await Promise.all(
    journals.map(async (journal) => {
      try {
        const attendances = await getAttendancesByJournal(journal);

        let total = attendances.reduce((value, data) => {
          return (value += data.payment);
        }, 0);

        // const getJournal = await getJournalByID(journal)
        const getJournal = await journal_model.find(journal);

        return getJournal.prepareUpdate((j) => {
          j.amount = total;
          j.last_updated_at = new Date().getTime();
        });
      } catch (err) {
      }
    })
  );
};

export const bulkDeleteJournal = async (allJournals) => {
  await database.write(async () => {
    const allRecords = await prepareDeletion(allJournals);
    await database.batch(...allRecords);
  });
};

const prepareDeletion = async (allJournals) => {
  return await Promise.all(
    allJournals.map(async (journal_model) => {
      try {
        return journal_model.prepareMarkAsDeleted();
      } catch (err) {
      }
    })
  );
};

export const bulkDeleteJournalsByBusiness = async (business_id) => {
  await database.write(async () => {
    let journals = await getJournalsByBusiness(business_id);
    const allRecords = await prepareDeletion(journals);
    await database.batch(...allRecords);
  });
};
